import { useState } from "react"
import { Typography } from "@stardust-ds/react"
import intl from "react-intl-universal"

import Modal from "../Modal"
import Button from "../../atoms/Button"
import RcmpAccordion from "../../atoms/Accordion"
import styles from "./index.module.scss"

export default function RcmpModalMove(props) {
  const {
    cTitle,
    bIsOpen,
    bOnClose,
    oGetData,
    fnGetPainelBoards,
    cInfoText,
    nCurrentId,
    fnSubmitMove,
    fnSubmitMoveData,
    bCollapse,
    fnGetDataPanel,
    aSubData,
    subDataId,
  } = props

  const [nPanelId, fnSetNPanelId] = useState(-1)
  const [bLoading, fnSetBLoading] = useState(false)

  async function fnHandleMoveModal() {
    if (nPanelId === undefined || nPanelId === -1) return null

    fnSetBLoading(true)
    await fnSubmitMove(nPanelId)
    fnSetBLoading(false)

    subDataId?.(-1)
    fnSetNPanelId(-1)
  }

  function fnUpdateDataPanel(data, nPanelId) {
    fnGetDataPanel?.(data, nPanelId)
  }
  function fnCloseModal() {
    if (bLoading) return

    subDataId?.(-1)
    fnSetNPanelId(-1)
    bOnClose(false)
  }

  return (
    <Modal isOpen={bIsOpen} size="sm">
      <Modal.Header onClose={fnCloseModal}>{cTitle}</Modal.Header>
      <Modal.Content size="sm">
        <div className={styles.header}>
          <Typography
            type="p1"
            textAlign="left"
            className={styles.accordionTitle}
          >
            {cInfoText}
          </Typography>
        </div>
        <RcmpAccordion
          fnUpdateDataPanel={fnUpdateDataPanel}
          oGetData={oGetData}
          bCollapse={bCollapse}
          fnGetSubData={fnGetPainelBoards}
          nCurrentId={nCurrentId}
          fnSetId={fnSetNPanelId}
          fnSetData={fnSubmitMoveData}
          subDataId={subDataId}
        >
          {aSubData}
        </RcmpAccordion>
      </Modal.Content>
      <Modal.Footer>
        <div className={styles.buttonFooterContainer}>
          <Button variant={"outline"} onClick={fnCloseModal} disabled={bLoading}>
            {intl.get("cancel")}
          </Button>
          <Button onClick={fnHandleMoveModal} isLoading={bLoading}>
            {intl.get("modal_move.move")}
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  )
}
